














































































































































































import { Component, Prop, Model, Vue } from "vue-property-decorator";
import { BPopover } from "bootstrap-vue";
import { randomId } from "@/utils";
import DatePicker from "vuejs-datepicker";

@Component({
  components: {
    BPopover,
    DatePicker,
  },
})
export default class PatientFilterPopover extends Vue {
  @Model("changed") readonly model!: string;
  @Prop(String) readonly toggleType!: string;
  @Prop(String) readonly toggleLabel!: string;
  @Prop() readonly toggleClass!: string;
  @Prop(String) readonly buttonIcon!: string;
  @Prop(String) readonly saveButtonIcon!: string;
  @Prop(String) readonly saveButtonLabel!: string;
  @Prop(String) readonly inputFirstName!: string;
  @Prop(String) readonly inputLastName!: string;
  @Prop(String) readonly inputMember!: string;
  @Prop(String) readonly inputEmrId!: string;
  @Prop(String) readonly inputBirthdateFrom!: string;
  @Prop(String) readonly inputBirthdateTo!: string;
  @Prop(String) readonly inputPhone!: string;
  @Prop(String) readonly inputCity!: string;
  @Prop(String) readonly inputGender!: string;
  @Prop(String) readonly title!: string;
  id = `patient-filter-popover-id-${randomId(6)}`;
  target = `patient-filter-popover-target-${randomId(6)}`;
  show = false;
  filter = this.defaultFilter();
  defaultFilter() {
    return {
      firstName: "",
      lastName: "",
      insurerMemberId: "",
      EMR_ID: "",
      birthdate: {
        from: "",
        to: "",
      },
      phone: "",
      city: "",
      gender: "",
    };
  }
  shown() {
    const { filter } = this;
    filter.firstName = this.inputFirstName || "";
    filter.lastName = this.inputLastName || "";
    filter.insurerMemberId = this.inputMember || "";
    filter.EMR_ID = this.inputEmrId || "";
    filter.birthdate.from = this.inputBirthdateFrom || "";
    filter.birthdate.to = this.inputBirthdateTo || "";
    filter.phone = this.inputPhone || "";
    filter.city = this.inputCity || "";
    filter.gender = this.inputGender || "";
    this.$emit("shown");
  }
  save() {
    const filter = JSON.parse(JSON.stringify(this.filter));
    this.$emit("changed", filter);
    this.close();
  }
  clear() {
    this.filter = this.defaultFilter();
    this.save();
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  mounted() {
    this.shown();
  }
}
